/*

  This function takes an array and a length as arguments and returns a new array that is filled with null values to match the length.

  Example: 
    - fillArrayWithNullToLength([1, 2, 3], 5) => [1, 2, 3, null, null]
    - fillArrayWithNullToLength([1, 2, 3], 3) => [1, 2, 3]

*/

export const fillArrayWithNullToLength = (array = [], length) => {
  return [...array, ...Array(length - array?.length).fill(null)]
}
